
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
import { NavBar, CreateUserModal, TeacherStudentModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    CreateUserModal,
    TeacherStudentModal
  }
})

export default class UsersView extends Vue {
  data () {
    return {
      isLoading: false,
      activeTab: 0,
      selectedTeacherId: null,
      spares: [],
      users: [],
      tutors: [],
      teachers: [],
      teacherStudents: [],
      allStudents: [],
      filteredStudents: [],
      apis: [],
      isApiModalOpen: false,
      isCreate: true,
      idx: -1,
      activeKey: '',
      externalType: null,
      isNewTutorModalOpen: false,
      isNewTeacherModalOpen: false,
      isAddStudentToTeacherModalOpen: false,
      startMailBox: 0,
      finishMailBox: 5,
      limitMailBox: 20,
      filaNameEmail: 'filaNameEmail'
    }
  }

  created () {
    this.$multiwatch(['selectedTeacherId'], function () {
      this.loadTeacherStudents()
    })
  }

  mounted () {
    this.getUsers()
    this.getSpareUsers()
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  openNewApiModal () {
    this.activeKey = ''
    this.idx = -1
    this.isCreate = true
    this.externalType = null
    this.openCreateUpdateApiModal()
  }

  openUpdateApiModal (obj: { idx: number, type: string, key: string }) {
    this.activeKey = obj.key
    this.idx = obj.idx
    this.isCreate = false
    this.externalType = obj.type
    this.openCreateUpdateApiModal()
  }

  openDeleteDialog (obj: { idx: number, type: string }) {
    this.$buefy.dialog.confirm({
      title: 'Delete',
      message: 'Are you sure to delete api key? You won\'t be able to recover it.',
      onConfirm: () => {
        this.deleteApi(obj.idx, obj.type)
      },
      canCancel: false
    })
  }

  userCreated () {
    this.isNewTeacherModalOpen = false
    this.isNewTutorModalOpen = false
    this.getUsers()
  }

  studentAddedToTeacher () {
    this.loadTeacherStudents()
    this.isAddStudentToTeacherModalOpen = false
  }

  openCreateUpdateApiModal () {
    this.isApiModalOpen = true
  }

  openNewTutorModal () {
    this.isNewTutorModalOpen = true
  }

  openNewTeacherModal () {
    this.isNewTeacherModalOpen = true
  }

  openAddStudentToTeacherModal () {
    this.isAddStudentToTeacherModalOpen = true
  }

  async loadTeacherStudents () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTeacherStudents/${this.selectedTeacherId}`))
      this.teacherStudents = resp
      this.filteredStudents = this.allStudents.filter(e => this.teacherStudents.findIndex(f => f.id === e.id) === -1)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get teacher students.',
        canCancel: false
      })
    }
  }

  async getUsers () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getUsers`))
      this.users = resp.filter(e => e.id !== this.loggedUserId)
      this.tutors = this.users.filter(e => e.roles.includes('TUTOR'))
      this.teachers = this.users.filter(e => e.roles.includes('TEACHER'))
      this.allStudents = this.users.filter(e => e.roles.includes('STUDENT'))
      this.filteredStudents = this.allStudents
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get Users.',
        canCancel: false
      })
    }
  }

  async removeStudentTeacher (studentId) {
    try {
      this.isLoading = true

      var data = {
        teacherId: this.selectedTeacherId,
        studentId
      }

      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/removeStudentToTeacher`, data)

      this.isLoading = false

      this.$buefy.dialog.confirm({
        title: 'Success',
        message: 'Student removed.',
        onConfirm: this.loadTeacherStudents,
        canCancel: false
      })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not remove. Reason: ${e}`,
        canCancel: false
      })
    }
  }

  async deleteApi (idx: number, type: string) {
    try {
      this.isLoading = true

      var resp
      var data = {
        type: type.toLowerCase(),
        userId: this.selectedTeacherId,
        idx
      }
      resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/deleteApiKey`, data)

      this.isLoading = false
      if (resp.error) {
        this.$buefy.dialog.confirm({
          title: 'Error',
          message: resp.error,
          canCancel: false
        })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Success',
          message: 'Api deleted successfully',
          onConfirm: this.loadTeacherStudents,
          canCancel: false
        })
      }
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Something went wrong. ${e}`,
        canCancel: false
      })
    }
  }

  async getSpareUsers () {
    this.isLoading = true
    try {
      this.spares = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getSpareUsers`))
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not create Spare Users. ${e}`,
        canCancel: false
      })
    }
  }

  async createSpareUsers () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/createSpareUsers/${1}`))
      this.getSpareUsers()
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not create Spare Users. ${e}`,
        canCancel: false
      })
    }
  }

  async getEmailsChunk (userId, idx) {
    this.isLoading = true
    try {
      var mailBox = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getEmailsChunk/${userId}/${this.startMailBox}/${this.finishMailBox}`))
      this.spares[idx].mailBox = mailBox
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get Spare User mailBox. ${e}`,
        canCancel: false
      })
    }
  }

  async getLastEmails (userId, idx) {
    this.isLoading = true
    try {
      var mailBox = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getLastEmails/${userId}/${this.limitMailBox}`))
      this.spares[idx].mailBox = mailBox
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get Spare User mailBox. ${e}`,
        canCancel: false
      })
    }
  }

  async getTotalNumberOnInboxEmails (userId, idx) {
    this.isLoading = true
    try {
      var total = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTotalNumberOnInboxEmails/${userId}`))
      this.spares[idx].totalEmails = total
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not reach User mailBox. ${e}`,
        canCancel: false
      })
    }
  }

  async getEmailBodyByFile (userId, idx) {
    this.isLoading = true
    try {
      var r = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getEmailBodyByFile/${userId}/${this.filaNameEmail}`))
      console.dir(r)
      this.spares[idx].emailBody = r?.body?.html
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not reach User mailBox. ${e}`,
        canCancel: false
      })
    }
  }

  async changeInboxFilePermissions (userId) {
    this.isLoading = true
    try {
      var r = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/changeInboxFilePermissions/${userId}`))
      console.log(r)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not reach User mailBox. ${e}`,
        canCancel: false
      })
    }
  }
}
